import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KeylessonRoutingModule } from './keylesson-routing.module';
import { KeylessonListComponent } from './keylesson-list/keylesson-list.component';
import { SharedModule } from '../shared/shared.module';
import { KeylessonDetailComponent } from './keylesson-detail/keylesson-detail.component';
import { KeylessonResolverService } from './keylesson-resolver.service';
import { KeylessonPlayerComponent } from './keylesson-player/keylesson-player.component';


@NgModule({
  declarations: [
    KeylessonListComponent, 
    KeylessonDetailComponent, KeylessonPlayerComponent
  ],
  imports: [
    CommonModule,
    KeylessonRoutingModule,
    SharedModule
  ]
})
export class KeylessonModule { }
